import { render, staticRenderFns } from "./MasterTypePower.vue?vue&type=template&id=3e5782ce&scoped=true"
import script from "./MasterTypePower.vue?vue&type=script&lang=js"
export * from "./MasterTypePower.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5782ce",
  null
  
)

export default component.exports